import styled from 'styled-components'
import { modalBodyHeight } from '../FileExplorer/FileExplorer.styles'

export const StyledFileTreeSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${modalBodyHeight}px;
`
